import {
  GET_SESSION,
  GET_SESSION_FAILED,
  GET_SESSION_SUCCEEDED,
  CREATE_SESSION,
  CREATE_SESSION_FAILED,
  CREATE_SESSION_SUCCEEDED,
  DESTROY_SESSION,
  DESTROY_SESSION_FAILED,
  DESTROY_SESSION_SUCCEEDED,
} from 'Redux/Types/SessionTypes'

const INITIAL_STATE = {
  loading: false,
  created: false,
  authToken: null,
  destroyed: false,
  createSessionError: null,
  authTokenExpirationDate: new Date().toISOString(),
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_SESSION:
      return state.isAuthenticated ? { ...state } : INITIAL_STATE
    case GET_SESSION_FAILED:
      return {
        ...state,
        isAuthenticated: false,
      }
    case GET_SESSION_SUCCEEDED:
      return {
        ...state,
        isAuthenticated: true,
        ...payload,
      }

    case CREATE_SESSION:
      return {
        ...state,
        createSessionError: null,
        created: false,
        loading: true,
      }

    case CREATE_SESSION_FAILED:
      return {
        ...state,
        createSessionError: payload,
        created: false,
        loading: false,
      }

    case CREATE_SESSION_SUCCEEDED:
      return {
        ...state,
        created: true,
        loading: false,
        isAuthenticated: true,
      }

    case DESTROY_SESSION:
      return {
        ...state,
        destroyed: false,
      }
    case DESTROY_SESSION_FAILED:
      return {
        ...state,
        destroyed: false,
      }
    case DESTROY_SESSION_SUCCEEDED:
      return {
        ...state,
        destroyed: true,
      }

    default:
      return state
  }
}
